import React from "react";
import ForNoVideoFound from "../ForNoVideoFound";

export default function HistoryComponent() {
  return (
    <div>
      <ForNoVideoFound />
    </div>
  );
}
